import { schema } from 'normalizr';
import { interactionSerializer } from './interaction.serializer';
import { IApiInteraction } from './interaction.types';

export const interactionSchema = new schema.Entity(
  'memberInteractionInfo',
  {},
  {
    idAttribute: (value: IApiInteraction) => value.id,
    processStrategy: interactionSerializer,
  }
);
